import { useTableStore } from 'components/TableWithCheck/selectTableStore';
import { useMemo } from 'react';

export const useTableSelectedList = KEY => {
  const {
    setSelectedItemsByListId,
    updateSelectedItemsByListAndId,
    updateSelectedItemsByList,
    deleteSelectedItemsByListAndId,
    selectedItems: selectedItemsFromTable,
    ...rest
  } = useTableStore();

  const selectedItems = useMemo(
    () => selectedItemsFromTable?.[KEY],
    [KEY, selectedItemsFromTable]
  );
  const setSelectedItems = values => setSelectedItemsByListId(KEY, values);

  const updateSelectedItemsById = (itemId, values) =>
    updateSelectedItemsByListAndId(KEY, itemId, values);

  const deleteSelectedItemsById = itemId =>
    deleteSelectedItemsByListAndId(KEY, itemId);

  const reset = () => setSelectedItemsByListId(KEY, []);

  return {
    ...rest,
    reset,
    selectedItems,
    setSelectedItems,
    updateSelectedItemsById,
    deleteSelectedItemsById,
    updateSelectedItemsByList,
  };
};
